import { render, staticRenderFns } from "./ChallengeCard.vue?vue&type=template&id=d7dc1936&"
import script from "./ChallengeCard.vue?vue&type=script&lang=ts&"
export * from "./ChallengeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports